import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navemenu from '../Navemenu/Navemenu';
import Footer from '../Footer/Footer';
import { Helmet } from 'react-helmet';
import './Blogs.scss';
import Pagination from '../Pagination/Pagination';
import axios from 'axios';

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const postsPerPage = 9;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    fetchBlogs(currentPage);
  }, [currentPage]);


  const WORDPRESS_API = 'https://lavenderblush-louse-758819.hostingersite.com/blog/wp-json/wp/v2';

  const fetchBlogs = async (page = 1) => {
    try {
      setLoading(true);
      setError(null);
      
     
      const proxyUrl = 'https://cors-anywhere.herokuapp.com/';
      const targetUrl = `${WORDPRESS_API}/posts?_embed&per_page=${postsPerPage}&page=${page}`;
      
      const response = await axios.get(proxyUrl + targetUrl, {
        timeout: 10000,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      
      console.log('API Response:', response.data);
      
      if (response.data && Array.isArray(response.data)) {
        
        const totalPosts = response.headers['x-wp-total'] || response.data.length;
        const calculatedTotalPages = Math.ceil(totalPosts / postsPerPage);
        
        setBlogs(response.data);
        setTotalPages(calculatedTotalPages);
        setLoading(false);
      } else {
        throw new Error('Invalid response format');
      }
      
    } catch (err) {
      console.error('Error details:', err);
      
      
      try {
        console.log('Trying direct fetch...');
        const directResponse = await axios.get(
          `${WORDPRESS_API}/posts?_embed&per_page=${postsPerPage}&page=${page}`,
          {
            timeout: 8000,
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }
          }
        );
        
        if (directResponse.data && Array.isArray(directResponse.data)) {
          const totalPosts = directResponse.headers['x-wp-total'] || directResponse.data.length;
          const calculatedTotalPages = Math.ceil(totalPosts / postsPerPage);
          
          setBlogs(directResponse.data);
          setTotalPages(calculatedTotalPages);
          setLoading(false);
          return;
        }
      } catch (directErr) {
        console.log('Direct fetch also failed:', directErr.message);
        
       
        setError(`
          Unable to fetch blogs due to CORS policy restrictions.
          
          To fix this:
          
          1. Go to WordPress Admin: https://lavenderblush-louse-758819.hostingersite.com/blog/wp-admin
          2. Install "Enable CORS" plugin
          3. OR add to .htaccess file:
          
          Header set Access-Control-Allow-Origin "*"
          Header set Access-Control-Allow-Methods "GET, POST, OPTIONS"
          Header set Access-Control-Allow-Headers "Content-Type"
        `);
        setLoading(false);
      }
    }
  };


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  const formatDate = (dateString) => {
    try {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString('en-US', options);
    } catch (e) {
      return '';
    }
  };


  const getFeaturedImage = (post) => {
    if (post._embedded && 
        post._embedded['wp:featuredmedia'] && 
        post._embedded['wp:featuredmedia'][0] &&
        post._embedded['wp:featuredmedia'][0].source_url) {
      return post._embedded['wp:featuredmedia'][0].source_url;
    }
   
    return 'https://via.placeholder.com/400x252/FF7722/FFFFFF?text=The+Good+Biker';
  };


  const stripHtml = (html) => {
    if (!html) return '';
    try {
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || '';
    } catch (e) {
      return html.replace(/<[^>]*>/g, '');
    }
  };

 
  const getExcerpt = (post, length = 100) => {
    let content = '';
    
    if (post.excerpt && post.excerpt.rendered) {
      content = stripHtml(post.excerpt.rendered);
    } else if (post.content && post.content.rendered) {
      content = stripHtml(post.content.rendered);
    }
    
    content = content.trim();
    
    if (content.length > length) {
      return content.substring(0, length) + '...';
    }
    return content || 'Read more about this biking adventure...';
  };

  // Get category name
  const getCategoryName = (post) => {
    if (post._embedded && 
        post._embedded['wp:term'] && 
        post._embedded['wp:term'][0] && 
        post._embedded['wp:term'][0].length > 0) {
      return post._embedded['wp:term'][0][0].name;
    }
    return 'BLOG';
  };

  // Get author name
  const getAuthorName = (post) => {
    if (post._embedded && 
        post._embedded.author && 
        post._embedded.author[0]) {
      return post._embedded.author[0].name;
    }
    return 'The Good Biker';
  };

  if (loading) {
    return (
      <div className='cmsPagesWrapper'>
        <Navemenu />
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading blogs</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='cmsPagesWrapper'>
        <Navemenu />
        <div className="error-container">
          <h2>API Connection Issue</h2>
          <div style={{ 
            background: '#f8f9fa', 
            padding: '20px', 
            borderRadius: '5px',
            margin: '20px 0',
            textAlign: 'left',
            whiteSpace: 'pre-line',
            fontFamily: 'monospace',
            fontSize: '14px'
          }}>
            {error}
          </div>
          
          <div style={{ marginTop: '20px' }}>
            <p><strong>Test these URLs in browser:</strong></p>
            <ul style={{ textAlign: 'left', display: 'inline-block' }}>
              <li><a href={`${WORDPRESS_API}/posts`} target="_blank" rel="noopener noreferrer">
                Test REST API
              </a></li>
              <li><a href="https://lavenderblush-louse-758819.hostingersite.com/blog/" target="_blank" rel="noopener noreferrer">
                Check WordPress Site
              </a></li>
            </ul>
          </div>
          
          <button 
            onClick={() => {
              setError(null);
              setLoading(true);
              fetchBlogs(currentPage);
            }} 
            className="retry-btn"
            style={{ marginTop: '20px' }}
          >
            Retry Connection
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className='cmsPagesWrapper'>
      <Navemenu />
      <Helmet>
        <meta charSet='utf-8' />
        <title>Blog - The Good Biker</title>
        <meta name='description' content='Check out the latest blogs and articles from The Good Biker.' />
        <meta name='keywords' content='motorcycle blogs, biking tips, riding gear, adventure biking' />
      </Helmet>
      
      <div className='container'>
        <div className='row'>
          <div className='col-12 col-lg-12'>
            <div className="staticBlogsInfo">
              <h1>Latest Blogs</h1>
              <p className="subtitle">Stay updated with the latest biking tips, gear reviews, and adventure stories</p>
              
              {blogs.length === 0 ? (
                <div className="no-blogs">
                  <h3>No blog posts yet</h3>
                  <p>WordPress connected successfully, but no posts found.</p>
                  <p>Create posts in WordPress admin to see them here.</p>
                </div>
              ) : (
                <>
                  <div className='row'>
                    {blogs.map((blog) => (
                      <div className='col-12 col-md-6 col-lg-4 mb-4' key={blog.id}>
                        <Link to={`/blogs/${blog.slug}`} className='blogsListLink'>
                          <div className='blogsList'>
                            <div className='bannerImg'>
                              <img 
                                src={getFeaturedImage(blog)} 
                                alt={stripHtml(blog.title.rendered) || 'Blog Image'} 
                                className='image img-fluid'
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = 'https://via.placeholder.com/400x252/FF7722/FFFFFF?text=The+Good+Biker';
                                }}
                              />
                              <div className="image-overlay">
                                <span className="category">
                                  {getCategoryName(blog)}
                                </span>
                              </div>
                              <div className="middle">&nbsp;</div>
                            </div>
                            <div className='blogsListInfo'>
                              <h2 dangerouslySetInnerHTML={{ __html: blog.title.rendered }} />
                              
                              <div className="blog-meta">
                                <span className="date">
                                  <i className="far fa-calendar"></i> {formatDate(blog.date)}
                                </span>
                                <span className="author">
                                  <i className="far fa-user"></i> {getAuthorName(blog)}
                                </span>
                              </div>
                              
                              <div className='blogShortInfo'>
                                <p>{getExcerpt(blog)}</p>
                              </div>
                              
                              <div className="read-more-wrapper">
                                <span className="read-more-btn">
                                  READ MORE <i className="fas fa-arrow-right"></i>
                                </span>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>
                  
              
                  {totalPages > 1 && blogs.length > 0 && (
                    <div className="pagination-container mt-5">
                      <Pagination 
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                      
                      <div className="page-info">
                        Page {currentPage} of {totalPages}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Blogs;